export default function AnnouncementBar() {
  return (
    <div className="bg-violet flex items-center justify-center flex-wrap gap-x-7 gap-y-1 px-5 py-2.5 font-syne text-[10.5px] font-medium tracking-[0.14em] uppercase text-white/80">
      <span>Now serving <strong className="text-white font-medium">NYC & New Jersey</strong></span>
      <span className="w-1 h-1 rounded-full bg-white/35 hidden sm:block" />
      <span><strong className="text-white font-medium">Woman & Minority Owned</strong> · SAM.gov Registered</span>
      <span className="w-1 h-1 rounded-full bg-white/35 hidden sm:block" />
      <span>48-hour quotes: <a href="mailto:events@oloyeevents.com" className="text-gold-glow hover:opacity-75 transition-opacity">events@oloyeevents.com</a></span>
    </div>
  );
}
